import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './Prices.css';

function Prices() {
  useEffect(() => {
    document.title = 'Prices | Sapium Beauty - Treatment Pricing London';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'View our competitive pricing for skin treatments and laser hair removal in London. Transparent pricing with course packages and savings. Book your free consultation.');
    }
  }, []);
  const [womenPricesOpen, setWomenPricesOpen] = useState(false);
  const [menPricesOpen, setMenPricesOpen] = useState(false);
  const [skinPricesOpen, setSkinPricesOpen] = useState(false);
  const [prx33Open, setPrx33Open] = useState(false);
  const [biorepeelFaceOpen, setBiorepeelFaceOpen] = useState(false);
  const [biorepeelHandsOpen, setBiorepeelHandsOpen] = useState(false);
  const [mandelicAcidPeelOpen, setMandelicAcidPeelOpen] = useState(false);
  const [azelaicAcidPeelOpen, setAzelaicAcidPeelOpen] = useState(false);
  const [glowPeelOpen, setGlowPeelOpen] = useState(false);
  const [microneedlingOpen, setMicroneedlingOpen] = useState(false);
  const [microneedlingChemicalPeelOpen, setMicroneedlingChemicalPeelOpen] = useState(false);
  const { t } = useTranslation();

  const toggleWomenPrices = () => setWomenPricesOpen(prev => !prev);
  const toggleMenPrices = () => setMenPricesOpen(prev => !prev);
  const toggleSkinPrices = () => setSkinPricesOpen(prev => !prev);
  const togglePrx33 = () => setPrx33Open(prev => !prev);
  const toggleBiorepeelFace = () => setBiorepeelFaceOpen(prev => !prev);
  const toggleBiorepeelHands = () => setBiorepeelHandsOpen(prev => !prev);
  const toggleMandelicAcidPeel = () => setMandelicAcidPeelOpen(prev => !prev);
  const toggleAzelaicAcidPeel = () => setAzelaicAcidPeelOpen(prev => !prev);
  const toggleGlowPeel = () => setGlowPeelOpen(prev => !prev);
  const toggleMicroneedling = () => setMicroneedlingOpen(prev => !prev);
  const toggleMicroneedlingChemicalPeel = () => setMicroneedlingChemicalPeelOpen(prev => !prev);

  return (
    <div className="prices-page">
      <section className="prices-hero">
        <div className="container">
          <h1>{t('prices.hero.title')}</h1>
          <p>{t('prices.hero.description')}</p>
        </div>
      </section>

      <section className="prices-section">
        <div className="container">
          <div style={{ marginBottom: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ margin: '0.5rem 0', fontWeight: '600' }}>Laser Hair Removal Prices</p>
            <p style={{ margin: '0.5rem 0', fontSize: '0.95rem' }}>Location: {t('services.locations.laserHairRemoval')}</p>
          </div>
          <div className="price-section">
            <button className="price-toggle" onClick={toggleWomenPrices}>
              {t('prices.categories.women')}
            </button>
            {womenPricesOpen && (
              <table className="price-table">
                <thead>
                  <tr>
                    <th>{t('prices.tableHeaders.service')}</th>
                    <th>{t('prices.tableHeaders.session1')}</th>
                    <th>{t('prices.tableHeaders.session3')}</th>
                    <th>{t('prices.tableHeaders.session6')}</th>
                    <th>{t('prices.tableHeaders.session8')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('prices.services.women.upperLip')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£25</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£170</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.chin')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£25</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£170</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.neck')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£25</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£170</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullFace')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£60</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£170</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£320</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£410</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.halfLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£200</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£370</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£480</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£110</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£310</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£580</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£750</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.underarms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.halfArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£70</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£200</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£370</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£480</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.tummyLine')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£35</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£100</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£190</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£240</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.brazilian')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£55</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£155</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£290</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£375</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.hollywood')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£75</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£215</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£400</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£520</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullFront')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.fullBack')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.platinumPackage')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£445</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£1335</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£2400</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£3000</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.women.goldPackage')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£345</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£1035</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£1552.50</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1932</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>

          <div className="price-section">
            <button className="price-toggle" onClick={toggleMenPrices}>
              {t('prices.categories.men')}
            </button>
            {menPricesOpen && (
              <table className="price-table">
                <thead>
                  <tr>
                    <th>{t('prices.tableHeaders.service')}</th>
                    <th>{t('prices.tableHeaders.session1')}</th>
                    <th>{t('prices.tableHeaders.session3')}</th>
                    <th>{t('prices.tableHeaders.session6')}</th>
                    <th>{t('prices.tableHeaders.session8')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('prices.services.men.chin')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.ears')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.eyebrows')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£15</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£40</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£75</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£95</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.nose')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.sideburns')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£40</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£110</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£210</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£270</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullFace')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£65</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£185</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£350</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£450</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.neck')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.beardSculpting')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£80</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£225</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£425</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£550</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.faceNeck')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£90</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£255</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£480</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£620</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.halfLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£99</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£280</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£530</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£680</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullLegs')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£150</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£425</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£800</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1000</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.buttocks')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£60</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£170</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£320</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£410</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.maleBrazilian')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£55</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£155</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£290</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£375</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.feetToes')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£50</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£140</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£260</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£340</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.underarms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.halfArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£65</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£185</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£350</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£450</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullArms')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£99</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£280</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£530</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£680</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.shoulders')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£30</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£85</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£160</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£200</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.stomach')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£55</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£155</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£290</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£375</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.chest')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£90</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£255</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£480</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£620</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.halfBack')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£99</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£280</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£530</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£680</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.fullBack')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£145</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£410</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£775</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1000</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.chestStomach')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£130</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£370</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£700</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£900</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.backShoulders')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£165</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£465</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£880</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£1120</td>
                  </tr>
                  <tr>
                    <td>{t('prices.services.men.maleFullBody')}</td>
                    <td data-label={t('prices.tableHeaders.session1')}>£445</td>
                    <td data-label={t('prices.tableHeaders.session3')}>£1335</td>
                    <td data-label={t('prices.tableHeaders.session6')}>£2400</td>
                    <td data-label={t('prices.tableHeaders.session8')}>£3000</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>

          <div style={{ marginTop: '2rem', marginBottom: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ margin: '0.5rem 0', fontWeight: '600' }}>Skin Treatments Prices</p>
            <p style={{ margin: '0.5rem 0', fontSize: '0.95rem' }}>Location: {t('services.locations.mainTreatments')}</p>
          </div>
          <div className="price-section">
            <button className="price-toggle" onClick={toggleSkinPrices}>
              {t('prices.categories.skin')}
            </button>
            {skinPricesOpen && (
              <div className="skin-treatments-content">
                {/* PRX-T33 Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={togglePrx33}>
                    <h3 className="treatment-heading">PRX-T33 Bio-Revitalisation Peel</h3>
                    <span className="dropdown-icon">{prx33Open ? '−' : '+'}</span>
                  </button>
                  {prx33Open && (
                    <table className="price-table">
                      <thead>
                        <tr>
                          <th>Treatment Area</th>
                          <th>1 Session</th>
                          <th>Course of 3</th>
                          <th>Course of 4</th>
                          <th>Course of 6</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Face</td>
                          <td data-label="1 Session">£120</td>
                          <td data-label="Course of 3">£330 <span className="savings">(save £30)</span></td>
                          <td data-label="Course of 4">£420 <span className="savings">(save £60)</span></td>
                          <td data-label="Course of 6">£600 <span className="savings">(save £120 — 1 session free!)</span></td>
                        </tr>
                        <tr>
                          <td>Face + Neck</td>
                          <td data-label="1 Session">£150</td>
                          <td data-label="Course of 3">£420 <span className="savings">(save £30)</span></td>
                          <td data-label="Course of 4">£520 <span className="savings">(save £80)</span></td>
                          <td data-label="Course of 6">£750 <span className="savings">(save £150 — 1 full session free!)</span></td>
                        </tr>
                        <tr>
                          <td>Face + Neck + Décolleté</td>
                          <td data-label="1 Session">£180</td>
                          <td data-label="Course of 3">£500 <span className="savings">(save £40)</span></td>
                          <td data-label="Course of 4">£620 <span className="savings">(save £100)</span></td>
                          <td data-label="Course of 6">£900 <span className="savings">(save £180 — 1 full session free!)</span></td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>

                {/* BioRePeel Face Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleBiorepeelFace}>
                    <h3 className="treatment-heading">BioRePeel — Face</h3>
                    <span className="dropdown-icon">{biorepeelFaceOpen ? '−' : '+'}</span>
                  </button>
                  {biorepeelFaceOpen && (
                    <table className="price-table">
                      <thead>
                        <tr>
                          <th>Treatment Area</th>
                          <th>1 Session</th>
                          <th>Course of 3</th>
                          <th>Course of 4</th>
                          <th>Course of 6</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Face</td>
                          <td data-label="1 Session">£90</td>
                          <td data-label="Course of 3">£240 <span className="savings">(save £30)</span></td>
                          <td data-label="Course of 4">£300 <span className="savings">(save £60)</span></td>
                          <td data-label="Course of 6">£450 <span className="savings">(1 session free!)</span></td>
                        </tr>
                        <tr>
                          <td>Face + Neck</td>
                          <td data-label="1 Session">£120</td>
                          <td data-label="Course of 3">£320 <span className="savings">(save £40)</span></td>
                          <td data-label="Course of 4">£400 <span className="savings">(save £80)</span></td>
                          <td data-label="Course of 6">£520 <span className="savings">(save £200 → over 1.5 sessions free!)</span></td>
                        </tr>
                        <tr>
                          <td>Face + Neck + Décolleté</td>
                          <td data-label="1 Session">£150</td>
                          <td data-label="Course of 3">£400 <span className="savings">(save £50)</span></td>
                          <td data-label="Course of 4">£500 <span className="savings">(save £100)</span></td>
                          <td data-label="Course of 6">£650 <span className="savings">(save £250 → more than 1.5 sessions free!)</span></td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>

                {/* BioRePeel Hands Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleBiorepeelHands}>
                    <h3 className="treatment-heading">BioRePeel — Hands</h3>
                    <span className="dropdown-icon">{biorepeelHandsOpen ? '−' : '+'}</span>
                  </button>
                  {biorepeelHandsOpen && (
                    <>
                      <table className="price-table">
                        <thead>
                          <tr>
                            <th>Treatment Area</th>
                            <th>1 Session</th>
                            <th>Course of 3</th>
                            <th>Course of 4</th>
                            <th>Course of 6</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Hands</td>
                            <td data-label="1 Session">£70</td>
                            <td data-label="Course of 3">£180 <span className="savings">(save £30)</span></td>
                            <td data-label="Course of 4">£230 <span className="savings">(save £50)</span></td>
                            <td data-label="Course of 6">£350 <span className="savings">(save £70 — 1 session half-price)</span></td>
                          </tr>
                        </tbody>
                      </table>
                      <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #ff69b4' }}>
                        <h4 style={{ margin: '0 0 0.5rem 0', color: '#1a1a1a', fontSize: '1.1rem' }}>➕ Add-On</h4>
                        <p style={{ margin: 0, color: '#333', fontSize: '1rem' }}>
                          <strong>Add Hands to any Face treatment — £50 per session</strong>
                        </p>
                      </div>
                    </>
                  )}
                </div>

                {/* Mandelic Acid Peel Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleMandelicAcidPeel}>
                    <h3 className="treatment-heading">Mandelic Acid Peel</h3>
                    <span className="dropdown-icon">{mandelicAcidPeelOpen ? '−' : '+'}</span>
                  </button>
                  {mandelicAcidPeelOpen && (
                    <>
                      <p style={{ marginTop: '1rem', marginBottom: '1rem', fontStyle: 'italic', color: '#666', fontSize: '0.95rem' }}>
                        (Gentle brightening peel — ideal for sensitive & darker skin types)
                      </p>
                      <table className="price-table">
                        <thead>
                          <tr>
                            <th>Treatment Area</th>
                            <th>1 Session</th>
                            <th>Course of 3</th>
                            <th>Course of 4</th>
                            <th>Course of 6</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Face</td>
                            <td data-label="1 Session">£90</td>
                            <td data-label="Course of 3">£240 <span className="savings">(save £30)</span></td>
                            <td data-label="Course of 4">£300 <span className="savings">(save £60)</span></td>
                            <td data-label="Course of 6">£450 <span className="savings">(1 session free)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck</td>
                            <td data-label="1 Session">£120</td>
                            <td data-label="Course of 3">£320 <span className="savings">(save £40)</span></td>
                            <td data-label="Course of 4">£400 <span className="savings">(save £80)</span></td>
                            <td data-label="Course of 6">£520 <span className="savings">(save £200 — over 1.5 sessions free)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck + Décolleté</td>
                            <td data-label="1 Session">£150</td>
                            <td data-label="Course of 3">£400 <span className="savings">(save £50)</span></td>
                            <td data-label="Course of 4">£500 <span className="savings">(save £100)</span></td>
                            <td data-label="Course of 6">£650 <span className="savings">(save £250 — more than 1.5 sessions free)</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>

                {/* Azelaic Acid Peel Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleAzelaicAcidPeel}>
                    <h3 className="treatment-heading">Azelaic Acid Peel</h3>
                    <span className="dropdown-icon">{azelaicAcidPeelOpen ? '−' : '+'}</span>
                  </button>
                  {azelaicAcidPeelOpen && (
                    <>
                      <p style={{ marginTop: '1rem', marginBottom: '1rem', fontStyle: 'italic', color: '#666', fontSize: '0.95rem' }}>
                        (Perfect for acne, pigmentation, rosacea & sensitive skin)
                      </p>
                      <table className="price-table">
                        <thead>
                          <tr>
                            <th>Treatment Area</th>
                            <th>1 Session</th>
                            <th>Course of 3</th>
                            <th>Course of 4</th>
                            <th>Course of 6</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Face</td>
                            <td data-label="1 Session">£90</td>
                            <td data-label="Course of 3">£240 <span className="savings">(save £30)</span></td>
                            <td data-label="Course of 4">£300 <span className="savings">(save £60)</span></td>
                            <td data-label="Course of 6">£450 <span className="savings">(1 session free)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck</td>
                            <td data-label="1 Session">£120</td>
                            <td data-label="Course of 3">£320 <span className="savings">(save £40)</span></td>
                            <td data-label="Course of 4">£400 <span className="savings">(save £80)</span></td>
                            <td data-label="Course of 6">£520 <span className="savings">(save £200 — over 1.5 sessions free)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck + Décolleté</td>
                            <td data-label="1 Session">£150</td>
                            <td data-label="Course of 3">£400 <span className="savings">(save £50)</span></td>
                            <td data-label="Course of 4">£500 <span className="savings">(save £100)</span></td>
                            <td data-label="Course of 6">£650 <span className="savings">(save £250 — more than 1.5 sessions free)</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>

                {/* Glow Peel Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleGlowPeel}>
                    <h3 className="treatment-heading">Glow Peel</h3>
                    <span className="dropdown-icon">{glowPeelOpen ? '−' : '+'}</span>
                  </button>
                  {glowPeelOpen && (
                    <>
                      <p style={{ marginTop: '1rem', marginBottom: '1rem', fontStyle: 'italic', color: '#666', fontSize: '0.95rem' }}>
                        (Light exfoliation for radiance & smoother texture)
                      </p>
                      <table className="price-table">
                        <thead>
                          <tr>
                            <th>Treatment Area</th>
                            <th>1 Session</th>
                            <th>Course of 3</th>
                            <th>Course of 4</th>
                            <th>Course of 6</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Face</td>
                            <td data-label="1 Session">£70</td>
                            <td data-label="Course of 3">£180 <span className="savings">(save £30)</span></td>
                            <td data-label="Course of 4">£220 <span className="savings">(save £60)</span></td>
                            <td data-label="Course of 6">£300 <span className="savings">(save £120 — nearly 2 sessions free!)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck</td>
                            <td data-label="1 Session">£90</td>
                            <td data-label="Course of 3">£230 <span className="savings">(save £40)</span></td>
                            <td data-label="Course of 4">£280 <span className="savings">(save £80)</span></td>
                            <td data-label="Course of 6">£380 <span className="savings">(save £160 — over 1.5 sessions free)</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>

                {/* Microneedling Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleMicroneedling}>
                    <h3 className="treatment-heading">Microneedling</h3>
                    <span className="dropdown-icon">{microneedlingOpen ? '−' : '+'}</span>
                  </button>
                  {microneedlingOpen && (
                    <>
                      <p style={{ marginTop: '1rem', marginBottom: '1rem', fontStyle: 'italic', color: '#666', fontSize: '0.95rem' }}>
                        (Advanced Collagen Induction Therapy with Dr Pen A20)
                      </p>
                      <table className="price-table">
                        <thead>
                          <tr>
                            <th>Treatment Area</th>
                            <th>1 Session</th>
                            <th>Course of 3</th>
                            <th>Course of 4</th>
                            <th>Course of 6</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Face</td>
                            <td data-label="1 Session">£100</td>
                            <td data-label="Course of 3">£270 <span className="savings">(save £30)</span></td>
                            <td data-label="Course of 4">£340 <span className="savings">(save £60)</span></td>
                            <td data-label="Course of 6">£500 <span className="savings">(save £100 — 1 full session free!)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck</td>
                            <td data-label="1 Session">£150</td>
                            <td data-label="Course of 3">£400 <span className="savings">(save £50)</span></td>
                            <td data-label="Course of 4">£500 <span className="savings">(save £100)</span></td>
                            <td data-label="Course of 6">£700 <span className="savings">(save £200 — over 1 full session free!)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck + Décolleté</td>
                            <td data-label="1 Session">£200</td>
                            <td data-label="Course of 3">£550 <span className="savings">(save £50)</span></td>
                            <td data-label="Course of 4">£680 <span className="savings">(save £120)</span></td>
                            <td data-label="Course of 6">£900 <span className="savings">(save £300 — 1.5 sessions free!)</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>

                {/* Microneedling + Chemical Peel Section */}
                <div className="treatment-dropdown">
                  <button className="treatment-toggle" onClick={toggleMicroneedlingChemicalPeel}>
                    <h3 className="treatment-heading">Microneedling + Chemical Peel</h3>
                    <span className="dropdown-icon">{microneedlingChemicalPeelOpen ? '−' : '+'}</span>
                  </button>
                  {microneedlingChemicalPeelOpen && (
                    <>
                      <p style={{ marginTop: '1rem', marginBottom: '1rem', fontStyle: 'italic', color: '#666', fontSize: '0.95rem' }}>
                        (Advanced Collagen Induction with Chemical Bio-Resurfacing)
                      </p>
                      <table className="price-table">
                        <thead>
                          <tr>
                            <th>Treatment Area</th>
                            <th>1 Session</th>
                            <th>Course of 3</th>
                            <th>Course of 4</th>
                            <th>Course of 6</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Face</td>
                            <td data-label="1 Session">£170</td>
                            <td data-label="Course of 3">£460 <span className="savings">(save £50)</span></td>
                            <td data-label="Course of 4">£600 <span className="savings">(save £80)</span></td>
                            <td data-label="Course of 6">£850 <span className="savings">(save £170)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck</td>
                            <td data-label="1 Session">£220</td>
                            <td data-label="Course of 3">£600 <span className="savings">(save £60)</span></td>
                            <td data-label="Course of 4">£780 <span className="savings">(save £100)</span></td>
                            <td data-label="Course of 6">£1,050 <span className="savings">(save £270)</span></td>
                          </tr>
                          <tr>
                            <td>Face + Neck + Décolleté</td>
                            <td data-label="1 Session">£270</td>
                            <td data-label="Course of 3">£750 <span className="savings">(save £60)</span></td>
                            <td data-label="Course of 4">£970 <span className="savings">(save £110)</span></td>
                            <td data-label="Course of 6">£1,300 <span className="savings">(save £320)</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Prices;
